<template>
  <div class="pc-data-edit">
    <h2>基础数据</h2>
    <div class="detail-data">
      <div class="area">
        <p class="name">{{ area.name }}</p>
        <el-input
          v-if="editRegion"
          v-model="area.value"
          placeholder="城市大小"
        ></el-input>
        <p v-else>{{ area.value }}</p>
        <el-input
          v-if="editRegion"
          v-model="area.year"
          placeholder="信息时间"
        ></el-input>
        <p v-else>{{ area.year }}</p>
      </div>
      <div class="population">
        <p class="name">{{ population.name }}</p>
        <el-input
          v-if="editRegion"
          v-model="population.value"
          placeholder="城市大小"
        ></el-input>
        <p v-else>{{ population.value }}</p>
        <el-input
          v-if="editRegion"
          v-model="population.year"
          placeholder="信息时间"
        ></el-input>
        <p v-else>{{ population.year }}</p>
      </div>
      <div class="gdp">
        <p class="name">{{ gdp.name }}</p>
        <el-input
          v-if="editRegion"
          v-model="gdp.value"
          placeholder="城市大小"
        ></el-input>
        <p v-else>{{ gdp.value }}</p>
        <el-input
          v-if="editRegion"
          v-model="gdp.year"
          placeholder="信息时间"
        ></el-input>
        <p v-else>{{ gdp.year }}</p>
      </div>
      <p class='topics'>
        WUPEN topics <a :href="'http://wupen.org/searchResult?name='+ regionName" target="_blank">{{ topicNum }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import { searchContent } from "./regionDetail.gql";
export default {
  data() {
    return {
      area: { name: "Area", value: "", type: "basic", year: "" },
      population: { name: "Population", type: "basic", value: "", year: "" },
      gdp: { name: "GDP", type: "basic", value: "", year: "" },
      topicNum: 0,
    };
  },

  props: { dataDetail: Array, editRegion: Boolean,regionName: String },
  watch: {
    dataDetail(val, newval) {
      if (val) {
        val.forEach((item) => {
          if (item.name == "Area") {
            this.area = item;
          }
          if (item.name == "Population") {
            this.population = item;
          }
          if (item.name == "GDP") {
            this.gdp = item;
          }
        });
      }
    },
    regionName(val) {
      this.getTopics();
    },
  },
  methods: {
    getBasicData() {
      let data = {
        area: this.area,
        population: this.population,
        gdp: this.gdp,
      };
      return data;
    },
    getTopics() {
      this.$global
        .GraphqlQuery(this, searchContent, {
          // Parameters
          content: this.regionName,
        })
        .then((res) => {
          this.topicNum = res.total;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.pc-data-edit {
  box-shadow: $boxshadow;
  padding: 35px 30px 20px;
  margin-top: 40px;
  > h2 {
    border-bottom: 1px solid $border-color;
    font-size: 20px;
    padding-bottom: 15px;
    color: $mainTitle;
    margin-bottom: 20px;
  }
  .detail-data {
    margin-top: 60px;
    .area,
    .population,
    .gdp {
      margin-bottom: 20px;
      display: flex;
      /deep/ .el-input {
        width: 200px;
        margin-left: 20px;
      }
      .name {
        width: 150px;
      }
      p {
        width: 120px;
      }
    }
    .topics{
      font-size: 18px;
      margin-top:58px;
      a{
        color:$lightenYellow;
        margin-left:20px;
        font-weight:600;
        font-size: 24px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/map/regionDetail/regionDetailData.vue